var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-toolbar-items",
    [
      _c(
        "v-btn",
        {
          staticClass: "announcement-toggle",
          attrs: { flat: "", dark: "" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.showAnnouncements.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "v-badge",
            {
              attrs: { value: _vm.unreadCount, color: "red" },
              scopedSlots: _vm._u([
                {
                  key: "badge",
                  fn: function() {
                    return [
                      _c("div", { attrs: { dark: "" } }, [
                        _vm._v(_vm._s(_vm.unreadCount))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "v-icon",
                {
                  class: _vm.hasImportantNotification ? "ringBell" : "",
                  attrs: { dark: "" }
                },
                [_vm._v("\n        notifications\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { width: "800", scrollable: "", persistent: "" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.closeAnnouncements.apply(null, arguments)
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", { staticClass: "mx-auto" }, [
                    _vm._v(_vm._s(_vm.$t("notification")))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  !_vm.isComponentMode
                    ? _c(
                        "v-container",
                        {
                          staticStyle: { "min-height": "100px" },
                          attrs: { fluid: "", "grid-list-lg": "" }
                        },
                        [
                          _vm.allAnnouncementKeys.length +
                            _vm.notifications.length && _vm.dialog
                            ? _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    color: "transparent",
                                    "show-arrows": "",
                                    primary: ""
                                  },
                                  model: {
                                    value: _vm.tab,
                                    callback: function($$v) {
                                      _vm.tab = $$v
                                    },
                                    expression: "tab"
                                  }
                                },
                                [
                                  _vm._l(_vm.announcementsMapKey, function(
                                    announcementKey
                                  ) {
                                    return _c(
                                      "v-tab",
                                      {
                                        key: announcementKey,
                                        staticClass: "announcement-tab",
                                        attrs: { ripple: "" }
                                      },
                                      [
                                        _c(
                                          "v-badge",
                                          {
                                            attrs: {
                                              value: _vm.getUnreadCountByKey(
                                                announcementKey
                                              ),
                                              small: "",
                                              color: "red"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "badge",
                                                  fn: function() {
                                                    return [
                                                      _c("div", {
                                                        attrs: { dark: "" }
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  announcementKey !== "general"
                                                    ? _vm.announcementsMap.get(
                                                        announcementKey
                                                      )[0].broadcasterName
                                                    : "General"
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.announcementsMapKey, function(
                                    announcementKey
                                  ) {
                                    return _c(
                                      "v-tab-item",
                                      { key: announcementKey },
                                      [
                                        announcementKey === "general"
                                          ? _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              _vm._l(
                                                _vm.notifications,
                                                function(notification) {
                                                  return _c(
                                                    "v-flex",
                                                    {
                                                      key: notification.key,
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          attrs: {
                                                            hover: "",
                                                            raised: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.clickNotification(
                                                                notification
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-card-text", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardTitle"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "You have " +
                                                                    _vm._s(
                                                                      notification.displayName
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cardText"
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "underline"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Click to go to " +
                                                                        _vm._s(
                                                                          notification.pathName
                                                                        ) +
                                                                        " page"
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              _vm._l(
                                                _vm.announcementsMap.get(
                                                  announcementKey
                                                ),
                                                function(announcement, index) {
                                                  return _c(
                                                    "v-flex",
                                                    {
                                                      key:
                                                        "announcement" + index,
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          attrs: {
                                                            hover: "",
                                                            raised: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-text",
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cardTitle"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      announcement.broadcasterName +
                                                                        "  " +
                                                                        _vm.toDateString(
                                                                          announcement.startDate
                                                                        )
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "cardText"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      announcement.msgContent
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              (
                                                                announcement.attachments ||
                                                                []
                                                              ).length
                                                                ? _c(
                                                                    "v-layout",
                                                                    {
                                                                      attrs: {
                                                                        row: "",
                                                                        wrap: ""
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      announcement.attachments ||
                                                                        [],
                                                                      function(
                                                                        file,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "FsFileChip",
                                                                          {
                                                                            key:
                                                                              "file" +
                                                                              index,
                                                                            staticClass:
                                                                              "ma-2",
                                                                            attrs: {
                                                                              file: file,
                                                                              width:
                                                                                "100%",
                                                                              "aspect-ratio":
                                                                                "1.7"
                                                                            }
                                                                          }
                                                                        )
                                                                      }
                                                                    ),
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            : _c(
                                "v-flex",
                                { attrs: { "text-md-center": "", md12: "" } },
                                [
                                  _vm._v(
                                    "\n            There is no notification now\n          "
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    : _c(
                        "v-container",
                        {
                          staticStyle: { "min-height": "100px" },
                          attrs: { fluid: "", "grid-list-lg": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            _vm._l(_vm.componentAnnouncements, function(
                              announcement,
                              index
                            ) {
                              return _c(
                                "v-flex",
                                {
                                  key: "announcement" + index,
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { hover: "", raised: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cardTitle" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  announcement.broadcasterName +
                                                    "  " +
                                                    _vm.toDateString(
                                                      announcement.startDate
                                                    )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "cardText" },
                                            [
                                              _vm._v(
                                                _vm._s(announcement.msgContent)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          (announcement.attachments || [])
                                            .length
                                            ? _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                _vm._l(
                                                  announcement.attachments ||
                                                    [],
                                                  function(file, index) {
                                                    return _c("FsFileChip", {
                                                      key: "file" + index,
                                                      staticClass: "ma-2",
                                                      attrs: {
                                                        file: file,
                                                        width: "100%",
                                                        "aspect-ratio": "1.7"
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          announcement.isImportant
                                            ? _c(
                                                "div",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "isReadBtn",
                                                    attrs: {
                                                      label: _vm.$t("read")
                                                    },
                                                    on: {
                                                      change: function(value) {
                                                        return _vm.readAnnouncement(
                                                          value,
                                                          announcement
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: { click: _vm.closeAnnouncements }
                    },
                    [_vm._v(_vm._s(_vm.$t("close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00fbd1ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00fbd1ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnouncementWidget.vue
// module id = null
// module chunks = 